import { Node, mergeAttributes } from '@tiptap/core';
/**
 * This extension allows you to create list items.
 * @see https://www.tiptap.dev/api/nodes/list-item
 */

var ListItem = Node.create({
  name: 'listItem',
  addOptions: function addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: 'bulletList',
      orderedListTypeName: 'orderedList'
    };
  },
  content: 'paragraph block*',
  defining: true,
  parseHTML: function parseHTML() {
    return [{
      tag: 'li'
    }];
  },
  renderHTML: function renderHTML(_ref) {
    var HTMLAttributes = _ref.HTMLAttributes;
    return ['li', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
  },
  addKeyboardShortcuts: function addKeyboardShortcuts() {
    var _this = this;

    return {
      Enter: function Enter() {
        return _this.editor.commands.splitListItem(_this.name);
      },
      Tab: function Tab() {
        return _this.editor.commands.sinkListItem(_this.name);
      },
      'Shift-Tab': function ShiftTab() {
        return _this.editor.commands.liftListItem(_this.name);
      }
    };
  }
});
export { ListItem, ListItem as default };